import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, LazyImport } from 'owa-bundling';
import { Loading, NetworkError } from 'owa-interstitial';

import type { ComponentProps } from 'react';
import type { LazyComponent, LazyModuleType } from 'owa-bundling';
import type { HybridspaceWorkWeekCalendarSurfaceProps } from './HybridspaceWorkWeekCalendarSurface/HybridspaceWorkWeekCalendarSurface';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "HybridspaceWorkWeekCalendarSurface" */ './lazyIndex'),
    { name: 'HybridspaceWorkWeekCalendarSurface' }
);

export const HybridspaceWorkWeekCalendarSurface: LazyComponent<
    HybridspaceWorkWeekCalendarSurfaceProps,
    any,
    void
> = createLazyComponent<
    ComponentProps<typeof lazyIndex.HybridspaceWorkWeekCalendarSurface>,
    LazyModuleType<typeof lazyModule>,
    any
>(lazyModule, m => m.HybridspaceWorkWeekCalendarSurface, Loading, NetworkError);

export const lazyHybridspaceWorkWeekCalendarSurfaceModule: LazyImport<
    typeof lazyIndex,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m);
